import { Link } from 'react-router';
import { Brain } from '@phosphor-icons/react';
import { useMemoryCount } from '~/hooks/queries/use-inspector';

export function MemorySnapshot() {
  const { data, isLoading, error } = useMemoryCount();

  if (isLoading) {
    return <div className="text-xs text-muted-foreground/70 py-1">Loading…</div>;
  }
  if (error || !data) {
    return (
      <div className="text-xs text-destructive py-1">
        Failed to load memory count
      </div>
    );
  }

  return (
    <Link
      to="/memory"
      className="flex items-center gap-2 px-2 py-1.5 rounded-md text-foreground/80 hover:text-foreground hover:bg-muted transition-colors"
    >
      <Brain size={16} weight="regular" className="shrink-0 text-muted-foreground" />
      <span className="flex-1 text-sm">
        {data.total} item{data.total === 1 ? '' : 's'}
      </span>
      <span className="text-[length:var(--text-2xs)] tabular-nums text-muted-foreground/70">
        {data.entities} entities · {data.documents} docs
      </span>
    </Link>
  );
}
